import React from 'react'

function Button(props) {
    const { title, type = "button", onClick = () => {}, className = "" } = props;
    
    return (
        <button 
            type={type} 
            className={`btn ${className}`} 
            onClick={onClick}
        >
            {title}
        </button>
    );
}

export default Button